import logoPng from "@/images/logo.png";
import closePng from "@/images/icon-close.svg";
import "./headerModalM.less";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { Button, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

interface menuItem {
  key: string;
  label: string;
  path: string;
  pathKeyLsit: string[];
}

const menuList: menuItem[] = [
  {
    key: "home",
    label: "首页",
    path: "/home",
    pathKeyLsit: ["/home"],
  },
  {
    key: "productCenter",
    label: "产品中心",
    path: "/good/list",
    pathKeyLsit: ["/good"],
  },
  {
    key: "service",
    label: "服务中心",
    path: "/service",
    pathKeyLsit: ["/service", "/quickOrder"],
  },
  {
    key: "safetyGas",
    label: "安全用气",
    path: "/safetyGas",
    pathKeyLsit: ["/safetyGas"],
  },
];

const HeaderModalM = ({
  setShowModalM,
  isLogin,
  dropdownItem,
  onSelect,
  handeDropdownChange,
  openDropdown,
  userInfo,
  handleLoginOquit,
}: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState("");

  useEffect(() => {
    const { pathname } = location;
    const beginIndex = menuList.findIndex(
      ({ pathKeyLsit }) =>
        pathKeyLsit.findIndex((item) => pathname.startsWith(item)) > -1
    );
    if (beginIndex > -1) {
      const { key } = menuList[beginIndex];
      setSelected(key);
    } else {
      setSelected("");
    }
  }, [location]);

  const goPage: (item: menuItem) => void = (item) => {
    setShowModalM(false);
    navigate(item.path);
    setSelected(item.key);
  };

  return (
    <div className="header-info-modal">
      <div className="top">
        <img src={logoPng} alt="" />
        <img
          src={closePng}
          className="close"
          onClick={() => setShowModalM(false)}
          alt=""
        />
      </div>
      <div className="mall-menu">
        <ul>
          {menuList.map((item) => (
            <li
              className={selected === item.key ? "selected" : ""}
              key={item.key}
              onClick={() => goPage(item)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
      <div className="user-info">
        {!isLogin ? (
          <Button
            className="logo-btn"
            onClick={() => {
              navigate("/login");
            }}
            type="primary"
          >
            登录
          </Button>
        ) : (
          <div className="user-info-content">
            <div className="user-company">
              <Dropdown
                open={openDropdown}
                onOpenChange={handeDropdownChange}
                trigger={["click"]}
                placement="bottom"
                arrow
                menu={{
                  items: dropdownItem,
                  onSelect,
                  selectable: true,
                  defaultSelectedKeys: [
                    userInfo.curUserInfo?.userAccount || "",
                  ],
                  rootClassName: "dropdown-menu-content",
                }}
              >
                <Space>
                  <span>{userInfo.curUserInfo?.customerName}</span>
                  {dropdownItem && dropdownItem.length > 1 && <DownOutlined />}
                </Space>
              </Dropdown>
            </div>
            <span className="user-spline"></span>
            <span className="user-quit" onClick={handleLoginOquit}>
              退出
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderModalM;
